const baseBucketPath = 'https://static.bancointer.com.br/seguros/telemedicine'

const PDFUrlDictionary = {
  MANUAL: `${baseBucketPath}/manual-do-produto.pdf`,
  TERMS_CONDITIONS: `${baseBucketPath}/termos-e-condicoes.pdf`,
  PRIVACY_POLICY: `${baseBucketPath}/politica-de-privacidade.pdf`,
}

export default PDFUrlDictionary
